export const salesNotification = {
  // Header
  "header.title": "Notificação de Vendas",
  "header.subtitle": "Exiba alertas de compras para gerar prova social em tempo real.",
  
  // Toggle Principal
  "enable": "Notificação de Vendas",
  "enable.helper": "Exibe notificações de compra no player.",
  
  // Tabs
  "tab.basic": "Configurações",
  "tab.content": "Conteúdo",
  "tab.style": "Estilo",
  "tab.advanced": "Avançado",
  
  // Tab Configurações (era "Básico")
  "type.label": "Tipo de notificação",
  "type.simulated": "Simulada",
  "type.real": "Integração/Real",
  
  "startDelay.label": "Atraso inicial ({value}s)",
  "startDelay.helper": "Tempo para exibir a primeira notificação após o play.",
  
  "frequency.label": "Frequência ({value}s)",
  "frequency.helper": "Intervalo entre uma notificação e outra.",
  
  "duration.label": "Duração ({value}s)",
  "duration.helper": "Por quanto tempo a notificação permanece visível.",
  
  "loop.label": "Repetir em loop",
  "loop.helper": "Reinicia a sequência de notificações ao chegar ao fim.",
  
  "position.label": "Posição",
  "position.helper": "",
  
  // Posições
  "position.topLeft": "Superior Esquerda",
  "position.topCenter": "Superior Centro",
  "position.topRight": "Superior Direita",
  "position.middleLeft": "Centro Esquerda",
  "position.middleCenter": "Centro",
  "position.middleRight": "Centro Direita",
  "position.bottomLeft": "Inferior Esquerda",
  "position.bottomCenter": "Inferior Centro",
  "position.bottomRight": "Inferior Direita",
  
  // Tab Conteúdo
  "message.label": "Mensagem da Notificação",
  "message.placeholder": "{nome} de {cidade} acabou de comprar {produto}",
  "message.helper": "Digite qualquer mensagem. Use {nome}, {cidade} e {produto} opcionalmente para personalizar.",
  "message.freeText": "Texto livre permitido - variáveis são opcionais",
  "message.preview": "Prévia",
  "message.previewEmpty": "Adicione uma mensagem",
  
  "names.label": "Lista de nomes",
  "names.placeholder": "Ana, João, Maria, Pedro, Lucas",
  "names.helper": "Separe os nomes por vírgula.",
  
  "cities.label": "Lista de cidades",
  "cities.placeholder": "São Paulo, Rio de Janeiro, Belo Horizonte, Brasília, Salvador",
  "cities.helper": "Separe as cidades por vírgula.",
  
  "product.label": "Nome do produto",
  "product.placeholder": "(Produto)",
  
  // Tab Estilo
  "platform.label": "Plataforma",
  "platform.helper": "O ícone será exibido automaticamente conforme a plataforma.",
  "platform.braip": "Braip",
  "platform.cakto": "Cakto",
  "platform.cartpanda": "CartPanda",
  "platform.digitalguru": "Digital Guru",
  "platform.eduzz": "Eduzz",
  "platform.hotmart": "Hotmart",
  "platform.kirvano": "Kirvano",
  "platform.kiwify": "Kiwify",
  "platform.monetizze": "Monetizze",
  "platform.perfectpay": "Perfect Pay",
  "platform.ticto": "Ticto",
  "platform.vegaCheckout": "Vega",
  "platform.custom": "Personalizado",
  "platform.via": "Via {platformName}",
  
  "customIcon.label": "Ícone personalizado",
  "customIcon.helper": "Faça upload de um ícone personalizado (opcional)",
  
  "showIcon.label": "Mostrar ícone",
  
  "iconSize.label": "Ícone",
  "iconSize.small": "Pequeno",
  "iconSize.medium": "Médio",
  "iconSize.large": "Grande",
  
  "fontSize.label": "Fonte",
  "fontSize.small": "Pequeno",
  "fontSize.medium": "Médio",
  "fontSize.large": "Grande",
  
  "animation.label": "Animação",
  "animation.none": "Nenhuma",
  "animation.fade": "Desvanecer",
  "animation.slide": "Deslizar",
  "animation.slideUp": "Deslizar para cima",
  "animation.zoom": "Zoom",
  "animation.bounce": "Pular",
  
  "padding.label": "Margem",
  "padding.small": "Pequeno",
  "padding.medium": "Médio",
  "padding.large": "Grande",
  
  "borderRadius.label": "Raio da borda",
  "opacity.label": "Opacidade",
  "boxShadow.label": "Sombra",
  "textColor.label": "Cor do texto",
  "bgColor.label": "Cor de fundo",
  "borderColor.label": "Cor da borda",
  
  // Tab Avançado
  "sound.label": "Som",
  "sound.helper": "Reproduz um som curto junto da notificação.",
  
  "soundVolume.label": "Volume ({value}%)",
  "soundVolume.helper": "Ajuste o volume do som da notificação (0-100%).",
  
  "redirectUrl.label": "URL de redirecionamento (opcional)",
  "redirectUrl.placeholder": "https://exemplo.com/oferta",
  "redirectUrl.helper": "Ao clicar na notificação, abrir esta URL em nova aba.",
  
  // Erros
  "error.emptyTemplate": "O template da mensagem não pode estar vazio",
  "error.noNames": "Adicione pelo menos um nome",
  "error.noCities": "Adicione pelo menos uma cidade",
  "error.namesMissing": "Adicione nomes para usar a variável {nome}",
  "error.citiesMissing": "Adicione cidades para usar a variável {cidade}",
  "error.productMissing": "Adicione o produto para usar a variável {produto}",
  "error.invalidUrl": "URL inválida",
  "error.iconSize": "O arquivo deve ter no máximo 500KB",
  "error.iconUpload": "Erro ao carregar a imagem",
};
